define('shared/remote/payment/adyen/checkOrderStatus',[
    'shared/remote/ajax'
], function (
    ajax
) {
        return function (orderId) {
            return ajax({
                url: '/1/api/commerce-gateway/order/' + orderId,
                method: 'get'
            });
        };
    });

